import { startScroll, stopScroll } from "../utils/scroll-config";
import copyToClipboard from "./copy-to-clipboard";

export default function purchaseForm() {
  const popUp = document.querySelector(".pop-up_purchase");
  const purchaseButtons = document.querySelectorAll("[data-purchase-plan]");

  if (!popUp || !purchaseButtons.length) return;
  const closePopUp = popUp.querySelectorAll(".close_btn");
  const scrollMobile = popUp.querySelector(".scroll_mobile");

  const inputs = popUp.querySelectorAll(".input");
  const security = popUp.querySelector("#security");
  const labels = popUp.querySelectorAll(".input_row");

  const purchaseIcon = popUp.querySelector(".plan_icon img");
  const purchaseSent = popUp.querySelector(".purchaseSent");
  const purchaseConfirm = popUp.querySelector(".confirm_purchase");

  let selectedPlan = null;

  const isDesktop = window.innerWidth > 1024;


  function showPopUp(btn) {
    isDesktop ? stopScroll() : null;
    setPlanOptions(btn);
    popUp.classList.add("active");

    document.addEventListener("keydown", hideOnEscape);
    document.addEventListener("click", hideOnOutside);
  }

  const setPlanOptions = (btn) => {
    // Change thumb
    const plan = btn.closest(".product");
    purchaseIcon.src = plan.querySelector(".icon").dataset.imgSrc;

    // Set plan id
    const planInput = popUp.querySelector('[data-type="plan"]');
    planInput.value = selectedPlan;
  };

  function hidePopUp() {
    popUp.classList.remove("active");

    setTimeout(
      () => popUp.classList.remove("confirm_status", "success_status"),
      300
    );
    scrollMobile.scrollTo(0, 0);
    inputs.forEach((i) => !i.hidden && (i.value = ""));
    labels.forEach((l) => l.classList.remove("error", "active"));

    document.removeEventListener("keydown", hideOnEscape);
    document.removeEventListener("click", hideOnOutside);

    isDesktop ? startScroll() : null;
  }

  // Close PopUp on Escape keydown
  function hideOnEscape(e) {
    if (e.key === "Escape") hidePopUp();
  }

  // Close PopUp on click outside Popup
  function hideOnOutside(e) {
    if (e.target.id == "pop-up_purchase") hidePopUp();
  }

  const onValidateError = (errors) => {
    // Show payment popup if user exists
    if (errors.existing_user_login) {
      // console.log(errors.existing_user_login[0]);
      popUp.classList.add("confirm_status");
    } else {
      Object.keys(errors).forEach((k) => {
        let input = [...inputs].filter((i) => i.dataset.type === k);
        let label = input[0].closest("label");
        label.classList.add("error");
        label.querySelector(".tip").innerHTML = errors[k];
      });
    }
  };

  const onError = (error) => {
    hidePopUp();
  };

  // Send form via AJAX
  const purchaseForm = () => {
    purchaseSent.disabled = true;

    // Form data
    let data = new FormData();
    data.append("security", security.value);

    inputs.forEach((i) => data.append(i.dataset.type, i.value));
    labels.forEach((l) => l.classList.remove("error"));

    // Send request
    fetch(BAMBOO.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      body: data,
    })
      .then((response) => response.json())
      // .then((response) => response.text())
      .then((data) => {
        purchaseSent.disabled = false;

        if (data.error) {
          onError(data.error);
          // console.log(data.error);
        } else if (data.errors) {
          onValidateError(data.errors);
        } else if (data.success) {
          // location.reload();
          popUp.classList.add("confirm_status");
        } else {
          // popUp.classList.add("confirm_status");
          // console.log(data);
          // onError(
          //   "Something went wrong. Please try again later or contact your manager"
          // );
        }
      })
      .catch((err) => {
        purchaseSent.disabled = false;
        // console.log(err);
      });
  };

  // confirm form via AJAX
  const paymentConfirmForm = () => {
    // Form data
    let confirm = [...inputs].filter((i) => i.dataset.confirm);

    let data = new FormData();
    data.append("action", "submitPayment");
    confirm.forEach((i) => data.append(i.dataset.type, i.value));

    // Send request
    fetch(BAMBOO.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      body: data,
    })
      .then((response) => response.json())
      // .then((response) => response.text())
      .then((data) => {
        // purchaseSent.disabled = false;
        if (data.success) {
          popUp.classList.remove("confirm_status");
          popUp.classList.add("success_status");
        }

        // console.log(data);

        // popUp.classList.add("confirm_status");

        // if (data.error) {
        //   // onError(data.error);
        //   // console.log(data.error);
        // } else if (data.errors) {
        //   console.log("errors");
        //   // onValidateError(data.errors);
        // } else if (data.success) {
        //   // location.reload();
        //   popUp.classList.add("confirm_status");
        // } else {
        //   // console.log(data);
        //   // onError(
        //   //   "Something went wrong. Please try again later or contact your manager"
        //   // );
        // }
      })
      .catch((err) => {
        // purchaseSent.disabled = false;
        console.log(err);
      });
  };

  function onInput(input) {
    // console.dir(input);
    input.addEventListener("input", () => {
      let label = input.closest("label");
      let err = label.classList.contains("error");
      let v = input.value;
      if (err) label.classList.remove("error");
      label.classList.toggle("active", v);
    });
  }

  inputs.forEach((i) => onInput(i));
  purchaseButtons.forEach((p) => {
    p.addEventListener("click", (e) => {
      selectedPlan = p.dataset.purchasePlan;

      // console.log(selectedPlan);
      showPopUp(p);
    });
  });
  [...closePopUp].forEach((b) => b.addEventListener("click", hidePopUp));

  purchaseSent.addEventListener("click", purchaseForm);
  purchaseConfirm.addEventListener("click", paymentConfirmForm);
  copyToClipboard(popUp);
}
